module.exports = __webpack_public_path__ + "6f31db3931a3528fe3ae00fff428793e.png";